// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Loader, Toastr, Button, Label } from "@revvsales/components";

// Components Imports

// Action Imports
import { AssetActions } from "../../../../actions";

// Internal Imports
import { ASSET, EVENTS, LOADING_MSG } from "../../../../constants";
import { AmplitudeUtils } from "../../../../utils";

// Destructuring
const { amplitudeLogEvent } = AmplitudeUtils;
const { createAssetFolderAction } = AssetActions;
const { ASSET_PAGE_URL } = ASSET;
const {
  ASSET: { CREATE_FOLDER },
} = LOADING_MSG;
const ENTER_KEY = 13;

class CreateAssetFolderPopup extends Component {
  state = { folderName: "", showButtunLoader: false, errMsg: "" };

  componentDidMount() {
    if (this.folderNameInput) {
      this.folderNameInput.focus();
    }
  }

  _onInputChange = e => {
    if (e.target.value && e.target.value.includes("/")) {
      this.setState({
        errMsg: "Forward slash '/' is not allowed in folder name",
      });
    } else {
      this.setState({ folderName: e.target.value, errMsg: "" });
    }
  };

  _closePopup = () => {
    this.props.closePopup(false);
  };

  _handleKeyDown = e => {
    if (e.keyCode === ENTER_KEY && this.state.folderName !== "") {
      this._createFolderHandler();
    }
  };

  _createFolderHandler = () => {
    this.setState({ showButtunLoader: true, errMsg: "" });
    const { associatedFolderId } = this.props;
    const payload = {
      name: this.state.folderName,
      parent_id: associatedFolderId || null,
    };
    this.props
      .createAssetFolder(payload)
      .then(response => {
        const { id, name } = response.folder;
        this.setState({ showButtunLoader: false, errMsg: "" });
        const redirectUrl = this._getAssetFolderUrl(id, name);
        Toastr.showToastr({
          type: "success",
          message: `Folder ${name} created successfully.`,
          timeout: 3000,
        });
        amplitudeLogEvent(EVENTS.EVENT_NAMES.FOLDER_CREATED, {
          folderId: id,
        });
        this.props.history.push(encodeURI(encodeURI(redirectUrl)));
        this._closePopup();
      })
      .catch(error => {
        const err = error.response;
        console.error(
          `CreateAssetFolderPopup => _createFolderHandler => Error : ${error}`,
        );
        this.setState({
          showButtunLoader: false,
          errMsg:
            err && err.data && err.data.message
              ? err.data.message
              : "Something went wrong!..",
        });
      });
  };

  _getAssetFolderUrl = (folderId, folderName) =>
    `/${ASSET_PAGE_URL}/${folderName
      .toLocaleLowerCase()
      .split(" ")
      .join("-")}/${folderId}`;

  render() {
    const { folderName, showButtunLoader, errMsg } = this.state;
    const disabled = !folderName;
    const errMsgSpace = errMsg ? (
      <div className="createassetfolderpopup-error-message">{errMsg}</div>
    ) : null;
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        {showButtunLoader && (
          <Loader className="loader-bg-color" label={CREATE_FOLDER} />
        )}

        <div
          className="createassetfolderpopup-container"
          data-test="createassetfolderpopup-container">
          <div
            className="createassetfolderpopup-modal-heading"
            data-test="createassetfolderpopup-modal-heading">
            Create new folder
          </div>
          {errMsgSpace}
          <div className="createassetfolderpopup-form">
            <div
              className="createassetfolderpopup-form-field"
              data-test="createassetfolderpopup-templatename">
              <Label
                htmlFor="userEmail"
                data-test="createassetfolderpopup-templatename-label">
                Folder name
              </Label>
              <input
                className="form-control"
                data-test="createassetfolderpopup-templatename-inputfield"
                type="text"
                name="folderName"
                value={folderName}
                onChange={this._onInputChange}
                placeholder="Enter folder name"
                onKeyDown={this._handleKeyDown}
                ref={name => {
                  this.folderNameInput = name;
                }}
              />
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="createassetfolderpopup-template-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              data-test="createassetfolderpopup-template-clonetemplate-button"
              disabled={disabled}
              onClick={this._createFolderHandler}
              isLoading={showButtunLoader}>
              Create folder
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  createAssetFolder: createAssetFolderAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(CreateAssetFolderPopup);



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetLeftSection/CreateAssetFolderPopup/index.js